export type commissionBndes = { term: number; tax: number; tc: number };

const TAXES = [
  1.49, 1.59, 1.69, 1.79, 1.89, 1.99, 2.09, 2.19, 2.29, 2.39, 2.49, 2.59, 2.69,
  2.79, 2.89, 2.99, 3.09, 3.19, 3.29, 3.39, 3.49, 3.59, 3.69, 3.79, 3.89, 3.99,
];

export function getMinTax(): number {
  return Math.min(...TAXES);
}

export function getMaxTax(): number {
  return Math.max(...TAXES);
}

export function getTcBndes(term: number, tax: number): number {
  var spreadsheet = getBndesSpreadsheet();
  for (const element of spreadsheet) {
    if (element.term == term && element.tax == tax) {
      return element.tc;
    }
  }
  throw `Invalid parameters ${term} / ${tax}`;
}

export function getBndesSpreadsheet(): Array<commissionBndes> {
  var tcSheet = [
    //3 terms
    [
      29.7, 28.19, 26.69, 25.21, 23.75, 22.3, 20.88, 19.48, 18.09, 16.72, 15.37,
      14.03, 12.71, 11.41, 10.13, 8.86, 7.61, 6.37, 5.15, 3.95, 2.76, 1.58,
      0.42, -0.73, -1.86, -2.97,
    ],
    //4 terms
    [
      25.67, 24.39, 23.12, 21.86, 20.62, 19.39, 18.18, 16.98, 15.79, 14.62,
      13.46, 12.32, 11.18, 10.06, 8.96, 7.86, 6.78, 5.71, 4.65, 3.61, 2.57,
      1.55, 0.54, -0.46, -1.45, -2.42,
    ],
    //5 terms
    [
      23.28, 22.13, 20.99, 19.87, 18.75, 17.65, 16.56, 15.48, 14.41, 13.36,
      12.31, 11.28, 10.26, 9.24, 8.24, 7.25, 6.27, 5.3, 4.34, 3.4, 2.46, 1.53,
      0.61, -0.3, -1.2, -2.09,
    ],
    //6 terms
    [
      21.69, 20.63, 19.58, 18.54, 17.5, 16.48, 15.47, 14.48, 13.49, 12.51,
      11.54, 10.58, 9.63, 8.69, 7.76, 6.84, 5.93, 5.03, 4.13, 3.25, 2.38, 1.51,
      0.65, -0.2, -1.04, -1.87,
    ],
    //7 terms
    [
      20.54, 19.54, 18.55, 17.57, 16.6, 15.64, 14.69, 13.74, 12.81, 11.89,
      10.97, 10.07, 9.17, 8.29, 7.41, 6.54, 5.67, 4.82, 3.98, 3.14, 2.31, 1.49,
      0.68, -0.13, -0.92, -1.71,
    ],
    //8 terms
    [
      19.67, 18.72, 17.77, 16.84, 15.91, 14.99, 14.08, 13.19, 12.29, 11.41,
      10.54, 9.68, 8.82, 7.97, 7.13, 6.3, 5.48, 4.66, 3.85, 3.05, 2.26, 1.48,
      0.7, -0.07, -0.83, -1.59,
    ],
    //9 terms
    [
      18.98, 18.06, 17.15, 16.25, 15.36, 14.48, 13.6, 12.74, 11.88, 11.03,
      10.19, 9.36, 8.53, 7.72, 6.91, 6.11, 5.31, 4.53, 3.75, 2.98, 2.22, 1.46,
      0.71, -0.03, -0.77, -1.5,
    ],
    //10 terms
    [
      18.41, 17.52, 16.64, 15.77, 14.91, 14.05, 13.21, 12.37, 11.54, 10.72, 9.9,
      9.1, 8.3, 7.51, 6.72, 5.95, 5.18, 4.42, 3.66, 2.92, 2.18, 1.44, 0.72, 0.0,
      -0.72, -1.42,
    ],
    //11 terms
    [
      17.94, 17.07, 16.22, 15.37, 14.53, 13.7, 12.87, 12.06, 11.25, 10.45, 9.66,
      8.87, 8.1, 7.33, 6.56, 5.81, 5.06, 4.32, 3.59, 2.86, 2.14, 1.43, 0.72,
      0.02, -0.68, -1.36,
    ],
    //12 terms
    [
      117.54, 16.7, 15.86, 15.03, 14.21, 13.4, 12.6, 11.8, 11.01, 10.23, 9.46,
      8.69, 7.93, 7.18, 6.44, 5.7, 4.97, 4.25, 3.53, 2.82, 2.12, 1.42, 0.73,
      0.05, -0.63, -1.3,
    ],
    //13 terms
    [
      17.2, 16.38, 15.56, 14.75, 13.95, 13.15, 12.36, 11.58, 10.81, 10.05, 9.29,
      8.54, 7.8, 7.06, 6.33, 5.61, 4.9, 4.19, 3.49, 2.79, 2.1, 1.42, 0.75, 0.08,
      -0.59, -1.24,
    ],
    //14 terms
    [
      16.91, 16.1, 15.3, 14.5, 13.71, 12.93, 12.16, 11.4, 10.64, 9.89, 9.14,
      8.41, 7.68, 6.96, 6.24, 5.53, 4.83, 4.14, 3.45, 2.77, 2.09, 1.43, 0.76,
      0.11, -0.54, -1.19,
    ],
    //15 terms
    [
      16.65, 15.85, 15.06, 14.28, 13.51, 12.74, 11.98, 11.23, 10.48, 9.75, 9.02,
      8.29, 7.58, 6.87, 6.16, 5.47, 4.78, 4.1, 3.42, 2.75, 2.09, 1.43, 0.78,
      0.14, -0.5, -1.13,
    ],
    //16 terms
    [
      16.42, 15.64, 14.86, 14.09, 13.32, 12.57, 11.82, 11.08, 10.35, 9.62, 8.9,
      8.19, 7.48, 6.79, 6.09, 5.41, 4.73, 4.06, 3.39, 2.74, 2.08, 1.44, 0.8,
      0.16, -0.46, -1.09,
    ],
    //17 terms
    [
      16.21, 15.44, 14.67, 13.91, 13.16, 12.41, 11.67, 10.94, 10.22, 9.5, 8.8,
      8.09, 7.4, 6.71, 6.03, 5.36, 4.69, 4.03, 3.37, 2.72, 2.08, 1.44, 0.81,
      0.19, -0.43, -1.04,
    ],
    //18 terms
    [
      16.02, 15.26, 14.5, 13.75, 13.0, 12.27, 11.54, 10.82, 10.11, 9.4, 8.7,
      8.01, 7.32, 6.64, 5.97, 5.31, 4.65, 4.0, 3.35, 2.71, 2.08, 1.45, 0.83,
      0.21, -0.4, -1.0,
    ],
    //19 terms
    [
      15.84, 15.09, 14.34, 13.6, 12.86, 12.13, 11.42, 10.7, 10.0, 9.3, 8.61,
      7.93, 7.25, 6.58, 5.92, 5.26, 4.61, 3.97, 3.33, 2.7, 2.07, 1.46, 0.84,
      0.24, -0.36, -0.96,
    ],
    //20 terms
    [
      15.68, 14.93, 14.19, 13.45, 12.73, 12.01, 11.3, 10.6, 9.9, 9.21, 8.53,
      7.85, 7.18, 6.52, 5.87, 5.22, 4.58, 3.94, 3.31, 2.69, 2.07, 1.46, 0.86,
      0.26, -0.34, -0.92,
    ],
    //21 terms
    [
      15.52, 14.78, 14.05, 13.32, 12.6, 11.89, 11.19, 10.49, 9.8, 9.12, 8.45,
      7.78, 7.12, 6.46, 5.82, 5.18, 4.54, 3.91, 3.29, 2.68, 2.07, 1.46, 0.87,
      0.28, -0.31, -0.89,
    ],
    //22 terms
    [
      15.38, 14.64, 13.92, 13.2, 12.49, 11.78, 11.09, 10.4, 9.71, 9.04, 8.37,
      7.71, 7.06, 6.41, 5.77, 5.14, 4.51, 3.89, 3.27, 2.67, 2.06, 1.47, 0.88,
      0.29, -0.28, -0.86,
    ],
    //23 terms
    [
      15.24, 14.51, 13.79, 13.08, 12.37, 11.68, 10.99, 10.3, 9.63, 8.96, 8.3,
      7.65, 7.0, 6.36, 5.72, 5.1, 4.48, 3.86, 3.26, 2.65, 2.06, 1.47, 0.89,
      0.31, -0.26, -0.83,
    ],
    //24 terms
    [
      15.1, 14.38, 13.67, 12.96, 12.26, 11.57, 10.89, 10.22, 9.55, 8.88, 8.23,
      7.58, 6.94, 6.31, 5.68, 5.06, 4.45, 3.84, 3.24, 2.64, 2.05, 1.47, 0.9,
      0.33, -0.24, -0.8,
    ],
    //25 terms
    [
      14.98, 14.26, 13.55, 12.85, 12.16, 11.48, 10.8, 10.13, 9.47, 8.81, 8.16,
      7.52, 6.89, 6.26, 5.64, 5.02, 4.42, 3.82, 3.22, 2.63, 2.05, 1.47, 0.9,
      0.34, -0.22, -0.77,
    ],
    //26 terms
    [
      14.85, 14.14, 13.44, 12.75, 12.06, 11.38, 10.71, 10.05, 9.39, 8.74, 8.1,
      7.46, 6.83, 6.21, 5.6, 4.99, 4.39, 3.79, 3.2, 2.62, 2.04, 1.47, 0.91,
      0.35, -0.2, -0.75,
    ],
    //27 terms
    [
      14.74, 14.03, 13.34, 12.65, 11.96, 11.29, 10.63, 9.97, 9.32, 8.67, 8.03,
      7.4, 6.78, 6.17, 5.56, 4.95, 4.36, 3.77, 3.19, 2.61, 2.04, 1.47, 0.92,
      0.36, -0.18, -0.72,
    ],
    //28 terms
    [
      14.62, 13.92, 13.23, 12.55, 11.87, 11.2, 10.54, 9.89, 9.24, 8.6, 7.97,
      7.35, 6.73, 6.12, 5.52, 4.92, 4.33, 3.75, 3.17, 2.6, 2.03, 1.47, 0.92,
      0.37, -0.17, -0.7,
    ],
    //29 terms
    [
      14.51, 13.82, 13.13, 12.45, 11.78, 11.12, 10.46, 9.81, 9.17, 8.54, 7.91,
      7.29, 6.68, 6.08, 5.48, 4.89, 4.3, 3.72, 3.15, 2.58, 2.02, 1.47, 0.92,
      0.38, -0.15, -0.68,
    ],
    //30 terms
    [
      14.4, 13.71, 13.03, 12.36, 11.69, 11.03, 10.38, 9.74, 9.1, 8.47, 7.85,
      7.24, 6.63, 6.03, 5.44, 4.85, 4.27, 3.7, 3.13, 2.57, 2.02, 1.47, 0.93,
      0.39, -0.14, -0.66,
    ],
    //31 terms
    [
      14.3, 13.61, 12.94, 12.27, 11.6, 10.95, 10.3, 9.67, 9.04, 8.41, 7.8, 7.19,
      6.58, 5.99, 5.4, 4.82, 4.24, 3.68, 3.11, 2.56, 2.01, 1.47, 0.93, 0.4,
      -0.13, -0.64,
    ],
    //32 terms
    [
      14.2, 13.52, 12.84, 12.18, 11.52, 10.87, 10.23, 9.6, 8.97, 8.35, 7.74,
      7.13, 6.54, 5.95, 5.36, 4.79, 4.22, 3.65, 3.1, 2.55, 2.0, 1.46, 0.93,
      0.41, -0.11, -0.6,
    ],
    //33 terms
    [
      14.1, 13.42, 12.75, 12.09, 11.44, 10.79, 10.16, 9.53, 8.9, 8.29, 7.68,
      7.08, 6.49, 5.9, 5.33, 4.75, 4.19, 3.63, 3.08, 2.53, 1.99, 1.46, 0.93,
      0.41, -0.1, -0.61,
    ],
    //34 terms
    [
      14.0, 13.33, 12.66, 12.0, 11.36, 10.72, 10.08, 9.46, 8.84, 8.23, 7.63,
      7.03, 6.44, 5.86, 5.29, 4.72, 4.16, 3.61, 3.06, 2.52, 1.98, 1.46, 0.94,
      0.42, -0.09, -0.59,
    ],
  ];

  let spreadsheet: Array<commissionBndes> = new Array<commissionBndes>();

  for (var iTerm = 0; iTerm < tcSheet.length; iTerm++) {
    var term = iTerm + 3;
    for (var iTax = 0; iTax < tcSheet[iTerm].length; iTax++) {
      spreadsheet.push({
        term: term,
        tax: TAXES[iTax],
        tc: tcSheet[iTerm][iTax] / 100,
      });
    }
  }
  return spreadsheet;
}
